import React from 'react';
import PropTypes from 'prop-types';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Panel, DataRow, TextArea, Input} from '@ace-de/ui-components';

const CostCoverageCostCoveragePanel = props => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translateTab = createTranslateShorthand('saa_cost_coverage_tab');
    const {onChangeHandler, description, additionalServicesText} = props;

    return (
        <Panel
            title={translateTab('panel_title.cost_coverage')}
            qaIdent="saa-cost-coverage-cost-coverage"
        >
            <DataRow
                label={translateTab('data_row_label.description')}
                className={cx('ace-c-data-row--condensed')}
                qaIdent="sa-cost-coverage-description"
            >
                <TextArea
                    className={cx('global!ace-u-flex--grow-1')}
                    isResizable={false}
                    value={description}
                    onChange={value => onChangeHandler('description', value)}
                />
            </DataRow>
            <DataRow
                label={translateTab('data_row_label.additional_services')}
                className={cx('ace-c-data-row--condensed')}
                qaIdent="sa-cost-coverage-additional-services"
            >
                <Input
                    className={cx('global!ace-u-flex--grow-1')}
                    value={additionalServicesText}
                    onChange={value => onChangeHandler('additionalServicesText', value)}
                />
            </DataRow>
        </Panel>
    );
};

CostCoverageCostCoveragePanel.propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
    description: PropTypes.string,
    additionalServicesText: PropTypes.string,
};

CostCoverageCostCoveragePanel.defaultProps = {
    description: '',
    additionalServicesText: '',
};

export default CostCoverageCostCoveragePanel;
